var __jsx = React.createElement;
import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import LanguageIcon from '@mui/icons-material/Language';
import { Button } from './style';
import { i18n
//  useTranslation, config 
} from '../../../config/i18n';
import { MUBAZAR_LANGUAGES } from '../../../constants';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function LocaleSelect(_ref) {
  var id = _ref.id;
  // const { t } = useTranslation(['language']);
  var _useState = useState(null),
    anchorEl = _useState[0],
    setAnchorEl = _useState[1];
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var handleLanguage = function handleLanguage(lang) {
    return function () {
      i18n.changeLanguage(lang);
      handleClose();
    };
  };
  // console.log("anchorEl", anchorEl, "i18n.language:", i18n.language, "i18n.options.defaultLanguage:", i18n.options.defaultLanguage)
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Button, {
      size: "small",
      "aria-controls": id,
      "aria-haspopup": "true",
      onClick: handleClick,
      children: [/*#__PURE__*/_jsx(LanguageIcon, {
        fontSize: "small"
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "button",
        children: typeof i18n.language !== 'undefined' ? i18n.language : i18n.options.defaultLanguage
      })]
    }), /*#__PURE__*/_jsx(Menu, {
      id: id,
      anchorEl: anchorEl,
      keepMounted: true,
      open: Boolean(anchorEl),
      onClose: handleClose,
      children: Object.keys(MUBAZAR_LANGUAGES).map(function (lang) {
        return /*#__PURE__*/_jsx(MenuItem, {
          onClick: handleLanguage(lang),
          children: MUBAZAR_LANGUAGES[lang].nativeName
        }, lang);
      })
    })]
  });
}
LocaleSelect.defaultProps = {
  id: 'language-menu'
};